import {
  CommonHeader,
  CommonHeaderNavItem,
  CommonHeaderProductIdentity,
  CommonHeaderResponsiveMenu,
  CommonHeaderSignOut,
  LoadingSpinner,
} from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from '../../hooks/use-store';
import PracticeSelector from '../PracticeSelector/PracticeSelector';
import './Header.scss';

const Header = observer(() => {
  const loc = useLocation();
  const { globalStore } = useStore();

  return (
    <CommonHeader
      className='mycs-header'
      persistentMenu
      leftContent={
        <>
          <CommonHeaderResponsiveMenu
            onClick={() => runInAction(() => (globalStore.leftNavPanelShown = true))}
          />
          <CommonHeaderProductIdentity
            icon={
              <img
                src='/images/MyCornerstone_icon.svg'
                alt='IDEXX MyCornerstone'
                className='mycs-logo'
              />
            }
            productName={
              <>
                <span>IDEXX</span> MyCornerstone
              </>
            }
          />
        </>
      }
      rightContent={
        <>
          <CommonHeaderNavItem>
            <PracticeSelector
              disabled={globalStore.practiceSelectorDisabled || loc.pathname !== '/'}
            />
          </CommonHeaderNavItem>
          {globalStore.loggingOut ? (
            <LoadingSpinner />
          ) : (
            <CommonHeaderSignOut
              aria-label='Sign Out'
              onClick={() => void globalStore.signOut()}
              data-testid='sign-out-link'
            >
              Sign Out
            </CommonHeaderSignOut>
          )}
        </>
      }
    />
  );
});

export default Header;
